export default __webpack_public_path__ + "static/featureCards_connect-ed0c2599ac10961ad12a5cfde304acbe.mp4";